import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function Shippingpolicies() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row py-5 px-sm-5">
          <div className="col">
            <h1 className="text-center fw-bold">Shipping Policy</h1>
            <p className="mt-3">
              Shipping Policy ("Agreement") entered into by and between Color Kingdon 
              ("Company") and you ("Customer").
            </p>
            <ul className="mt-4">
              <li>
                <h5 className="fw-bold">1. Shipping Locations</h5>
                <p>
                  We ship premium colouring books across <strong>all India</strong>. 
                  Coverage includes major cities, towns, and most pin codes. 
                  Shipping availability is confirmed at checkout.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">2. Delivery Time</h5>
                <p>
                  <strong>Order Processing:</strong> 1-2 business days after payment confirmation.
                </p>
                <p>
                  <strong>Delivery Timeline:</strong>
                </p>
                <ul>
                  <li>Metro Cities: 2-4 business days</li>
                  <li>Major Cities: 3-5 business days</li>
                  <li>Remote Areas: 5-8 business days</li>
                </ul>
                <p><em>Total time from order to delivery: 3-10 business days</em></p>
              </li>
              <li>
                <h5 className="fw-bold">3. Shipping Charges</h5>
                <p>
                  <strong>Flat Rate Shipping:</strong> ₹79 across India (displayed at checkout)
                </p>
                <p>
                  <strong>FREE Shipping:</strong> On orders above ₹499
                </p>
                <p>
                  <strong>Bulk Orders:</strong> Special rates for schools, resellers, and wholesale - 
                  contact us for quotes.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">4. Payment Methods</h5>
                <p><strong>a. Cash on Delivery (COD)</strong></p>
                <ul>
                  <li>Pay cash upon delivery</li>
                  <li>COD Charge: ₹59 (added at checkout)</li>
                  <li>Available in 28,000+ pin codes</li>
                </ul>
                <p><strong>b. Online Payment (Recommended)</strong></p>
                <ul>
                  <li>Secure payments via <strong>Razorpay</strong></li>
                  <li>Cards, UPI, Net Banking, Wallets</li>
                  <li>Instant order confirmation</li>
                </ul>
              </li>
              <li>
                <h5 className="fw-bold">5. Order Tracking</h5>
                <p>
                  Receive tracking updates via <strong>Email & SMS</strong>. Track your order 
                  through Shipway or your registered mobile number on the courier website.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">6. Failed Delivery Attempts</h5>
                <p>
                  <strong>COD Orders:</strong> 3 delivery attempts. After failed attempts, 
                  order returns to us (COD fee non-refundable).
                </p>
                <p>
                  <strong>Prepaid Orders:</strong> Contact us at <a href="mailto:support@colorkingdon.in" className="text-success text-decoration-none">support@colorkingdon.in</a> 
                  or +91 9251952096 for rescheduling.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">7. Packaging & Protection</h5>
                <p>
                  All colouring books are packed with:
                </p>
                <ul>
                  <li>Bubble wrap protection for pages</li>
                  <li>Rigid cardboard separators</li>
                  <li>Waterproof outer packaging</li>
                  <li>Damage-free delivery guarantee</li>
                </ul>
              </li>
              <li>
                <h5 className="fw-bold">8. Courier Partners</h5>
                <p>
                  We partner with trusted couriers: <strong>Shipway, DTDC, Delhivery, Xpressbees</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Shippingpolicies;